/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Head, router, useForm } from "@inertiajs/react"

import { BusinessForm } from "@/components/businesses/business-form"
import AppLayout from "@/layouts/app-layout"
import { businessPath } from "@/routes"

interface Neighborhood {
  id: number
  name: string
}

interface Business {
  id: number
  business_name: string
  business_type: "restaurant" | "store" | "service" | "delivery"
  description: string
  phone: string
  email: string
  website?: string
  address: string
  latitude?: string
  longitude?: string
  neighborhood?: { id: number; name: string }
  opening_hours?: string
  delivery_coverage?: string
}

interface BusinessesEditProps {
  business: Business
  neighborhoods: Neighborhood[]
  errors?: Record<string, string>
  existing_images?: { id: number | string; url: string }[]
}

export default function BusinessesEdit({
  business,
  neighborhoods,
  errors = {},
  existing_images = [],
}: BusinessesEditProps) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data, setData, put, processing } = useForm<{ business: any }>({
    business: {
      business_name: business.business_name ?? "",
      business_type: business.business_type ?? "store",
      description: business.description ?? "",
      phone: business.phone ?? "",
      email: business.email ?? "",
      website: business.website ?? "",
      address: business.address ?? "",
      latitude: business.latitude ?? "",
      longitude: business.longitude ?? "",
      neighborhood_id: business.neighborhood?.id
        ? String(business.neighborhood.id)
        : "",
      opening_hours: business.opening_hours ?? "",
      delivery_coverage: business.delivery_coverage ?? "",
      images: [],
      image_urls: [],
    },
  })

  const submit = (e: React.FormEvent) => {
    e.preventDefault()
    put(businessPath(business.id), { forceFormData: true })
  }

  const err = errors as unknown as Record<string, string>

  return (
    <AppLayout>
      <Head title={`Editar negocio - ${business.business_name}`} />
      <div className="mx-auto max-w-6xl p-4 md:p-6">
        <BusinessForm
          title="Editar negocio"
          data={data.business}
          errors={err}
          neighborhoods={neighborhoods}
          processing={processing}
          existingImages={existing_images}
          onChange={(partial) =>
            // @ts-expect-error — Inertia useForm with dynamic nested data
            setData("business", { ...data.business, ...partial })
          }
          onSubmit={submit}
          onCancel={() => router.visit(businessPath(business.id))}
          submitLabel="Actualizar"
        />
      </div>
    </AppLayout>
  )
}
